import { setResources } from "./bootstrapResources";
import serverReference from "./serverReference-es-ES.json";
import resources from "./translations-es-ES.json";

setResources(resources, serverReference);